import { shallowEqual, useSelector } from 'react-redux';
import { Rootstate } from '../../store';


const useMapUtils = () => {
    const { zoom } = useSelector((state: Rootstate) => ({
        zoom: state.zoom.zoom,
    }), shallowEqual);

    const normalizedScale = 1/zoom;

    return {
        normalizedScale,
        scale: zoom,
    };
};


export default useMapUtils;
